import React from 'react';
import format from 'date-fns/format';
import get from 'lodash/get';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  colorFont: {
    color: theme.palette.primary.light,
    borderColor: theme.palette.primary.light
  }
});

const PeriodLabel = React.memo(({ period, asButton = false, classes, onClick }) => {
  if (asButton)
    return (
      <Button
        data-testid="periodLabel"
        variant="outlined"
        className={classes.colorFont}
        onClick={onClick}>
        {get(period, 'name', 'Select Week')}
      </Button>
    );

  if (!period) return null;

  const dateFrom = period.dateFrom && format(new Date(period.dateFrom), 'MMMM d, yyyy');
  const dateTo = period.dateTo && format(new Date(period.dateTo), 'MMMM d, yyyy');
  return (
    <>
      {period.name} • {dateFrom} - {dateTo}
    </>
  );
});

export default withStyles(styles)(PeriodLabel);
